import React from 'react';

import { highlight } from './syntax-highlighter';
import S from './Code.module.css';

import 'highlight.js/styles/atom-one-light.css';

interface Props {
  preClassName?: string;
  className?: string;
  language?: string;
  children: string;
}

export const Code = ({
  preClassName,
  className,
  language = className?.startsWith('language-')
    ? className.slice('language-'.length)
    : undefined,
  ...props
}: Props) => {
  if (language) {
    const highlightedCode = highlight({
      code: props.children.trim(),
      lang: language
    }).split('\n');

    const theCode = (
      <code className={className ?? `language-${language}`}>
        <ul className={S.lines}>
          {highlightedCode.map((item, idx) => (
            <li key={idx} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>
      </code>
    );
    return className?.startsWith('language-') ? (
      theCode
    ) : (
      <pre className={preClassName}>{theCode}</pre>
    );
  }

  return <code {...props} />;
};
